// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b71720b1","498":"3b582806","703":"29b97b89","787":"ea96b127"}[chunkId] + ".chunk.js";
};